import { useThemeColors } from '@/styles';
import { TruncatedText } from './truncated-text';
import { MarqueeText } from './marquee-text';

interface KeyValueRowProps {
  label: string;
  value: string;
  textBehavior?: 'truncate' | 'marquee' | 'wrap';
  maxValueWidth?: string;
}

export function KeyValueRow({
  label,
  value,
  textBehavior = 'marquee',
  maxValueWidth = '100%',
}: KeyValueRowProps) {
  const colors = useThemeColors();

  return (
    <div className="grid grid-cols-[auto_1fr] gap-4 items-center min-h-[24px]">
      <span
        className="text-sm whitespace-nowrap"
        style={{ color: colors.text.secondary }}
      >
        {label}
      </span>
      <div className="min-w-0 text-right" style={{ maxWidth: maxValueWidth }}>
        {textBehavior === 'truncate' && (
          <TruncatedText
            text={value}
            className="text-sm font-medium"
            style={{ color: colors.text.primary }}
          />
        )}
        {textBehavior === 'marquee' && (
          <MarqueeText
            text={value}
            className="text-sm font-medium text-right"
            style={{ color: colors.text.primary }}
          />
        )}
        {textBehavior === 'wrap' && (
          <span
            className="text-sm font-medium block break-words"
            style={{ color: colors.text.primary }}
          >
            {value}
          </span>
        )}
      </div>
    </div>
  );
}
